const definitionsSagaNamespace = 'definitions-saga';
export const LOAD_DEFINITIONS_BY_REFERENCE = `${definitionsSagaNamespace}/LOAD_DEFINITIONS_BY_REFERENCE`;
export const REMOVE_DEFINITIONS = `${definitionsSagaNamespace}/REMOVE_DEFINITIONS`;
export const EDIT_DEFINITION = `${definitionsSagaNamespace}/EDIT_DEFINITION`;
export const CREATE_DEFINITION = `${definitionsSagaNamespace}/CREATE_DEFINITION`;
export const LOAD_DEFINITIONS_BY_QUESTION = `${definitionsSagaNamespace}/LOAD_DEFINITIONS_BY_QUESTION`;
